<template>
  <div class="container salespersonLibray" v-loading="listLoading" element-loading-text="拼命加载中"
       element-loading-background="rgba(0, 0, 0, 0.6)">
    <div>
      <filter-tab @filterParam="getParam" :webId="1"></filter-tab>
    </div>
    <el-row>
      <div class="order-by clearfix">
        排序：
        <el-button round size="mini" @click="sortByAge" :class="{'is-active': formData.orderBy == 1}">年龄<i
            class="el-icon-d-caret el-icon--right"></i></el-button>
        <!-- <el-button round size="mini" @click="sortByCredit" :class="{'is-active': formData.orderBy == 2}">信用<i class="el-icon-d-caret el-icon--right"></i></el-button>
        <el-button round size="mini" @click="sortByStar" :class="{'is-active': formData.orderBy == 3}">星级<i class="el-icon-d-caret el-icon--right"></i></el-button>
        <el-button round size="mini" @click="sortByProPrice" :class="{'is-active': formData.orderBy == 4}">项目单价<i class="el-icon-d-caret el-icon--right"></i></el-button> -->
        <div class="floatr">
          <span class="total">
            共<span>{{total}}</span>位促销员
          </span>
          <span v-if="userIsPG && userIsPG == 'PGproject'">
            <el-button type="primary" size="mini" class="sellButton" @click="downloadModel" round>
              下载模板 <i class="el-icon-download"></i>
            </el-button>
            <el-button type="primary" size="mini" class="sellButton" @click="requireList" round>
              宝洁报表导入 <i class="el-icon-upload2"></i>
            </el-button>
            <el-button type="primary" size="mini" class="sellButton" @click="exportList" round>
              宝洁报表导出 <i class="el-icon-download"></i>
            </el-button>
          </span>
          <!-- <div class="listExport" :disable-transitions='true' @click="exportData">促销员列表导出</div> -->
        </div>
      </div>
    </el-row>
    <el-row style="overflow:hidden;">
      <div style="width:calc(100% + 186px);">
        <el-col class="sales-persion-card" v-for="(item, index) in dataList" :key="index">
          <div class="top-line" :class="{
            'long': item.isLongSign && !item.isShortSign,
            'short': !item.isLongSign && item.isShortSign,
            'both': item.isLongSign && item.isShortSign}"></div>
          <!--180820杜涛要求在新页面打开促销员详情。router的属性中添加tag="a"和target="_blank"即可在新的标签中打开跳转的页面，另外记得改为style="display:block"-->
          <router-link :to="userIsPLUS?{ path: '/salespersonDetail', query: { id: item.id , auths: auths}}:''" :class="{'pointer':userIsPLUS}" target="_blank" tag="a" style="display:block" rel="opener">
            <div class="tag">
              <span class="tag-item long" v-if="item.isLongSign">长</span>
              <span class="tag-item" v-if="item.isShortSign">短</span>
            </div>
            <div class="avatar" :style="avatarImg(item.headImg)">
              <img :src="item.headImg || ''" alt="" @error="setErrorImage">
            </div>
            <div class="name">
              {{item.name}}
              <div class="status" v-if="userIsPLUS" :class="{'on-guard': item.status == '项目中' ||  item.status === '在岗'}">{{item.status ===
                '项目中' || item.status === '在岗' ? '项目中' : '待岗中'}}
              </div>
            </div>
            <div class="persional-info">促销员ID:{{item.empPk}}</div>
            <div class="persional-info">{{item.age}}岁<span class="line"></span>{{item.height}}cm</div>
            <div class="info">
              <!-- <span v-if="(item.crmSignLst.length == 1 && item.crmSignLst[0].signName == '短促销') || item.crmSignLst.length == 2">项目数：{{item.projectNum || '/'}}</span>
              <span v-if="(item.crmSignLst.length == 1 && item.crmSignLst[0].signName == '长促销') || item.crmSignLst.length == 2">服务月：{{item.workMonth || '/'}}</span> -->
              <span class="tag-item long" v-if="item.isLongSign">服务月：{{item.workMonth || '/'}}</span>
              <span class="tag-item" v-if="item.isShortSign">项目数：{{item.projectNum || '/'}}</span>
            </div>
          </router-link>
        </el-col>
      </div>
    </el-row>
    <el-pagination class="pagination"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="formData.pageNo"
                   :page-sizes="[48, 96, 144]"
                   :page-size="formData.pageSize"
                   layout="slot, sizes, prev, pager, next, jumper"
                   :total="total">
      <slot>
        <span class="slot-element">共{{total}}位促销员</span>
      </slot>
    </el-pagination>

    <el-dialog class="dialog" title="导入宝洁数据" :visible.sync="uploadDialog" width="500px" center v-loading="load"
               element-loading-text="数据正在上传中..."
               element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="dialog-body">
        <el-upload
            class="upload-demo"
            action="/rest/upDownload/upload"
            :data="obj"
            :on-error="handleError"
            :on-success='handleSuccess'
            :before-upload="handlePreview"
            multiple
            :limit="3"
        >
          <el-button size="small" type="primary">点击上传</el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
	        <el-button class="dialog-btn" size="small" @click="uploadDialog = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import utils from '../../common/js/util.js'
  import FilterTab from 'components/filterTab'
  import avatarDefault from 'common/images/avatar-default.png'

  export default {
    components: {
      FilterTab
    },
    data() {
      return {
        total: null,
        formData: {
          name: null,
          idcard: null,
          provinceId: null,
          cityId: null,
          areaId: null,
          sex: null,
          educationId: null,
          status: null,
          starLevelId: null,
          agreement: null,
          channel: null,
          ageMin: null,
          ageMax: null,
          heightMin: null,
          heightMax: null,
          creditScoreMin: null,
          creditScoreMax: null,
          projectNumMin: null,
          projectNumMax: null,
          workMonthMin: null,
          workMonthMax: null,
          frequencyNumMin: null,
          frequencyNumMax: null,
          projectPriceMin: null,
          projectPriceMax: null,
          postId: 0,
          pageNo: 1,
          pageSize: 48,
          orderBy: null,
          orderByAd: null,
        },
        dataList: null,
        asc1: true,
        asc2: false,
        asc3: false,
        asc4: false,
        listLoading: false,
        usersName: '',

        avatarDefault: avatarDefault,

        // 页面内权限
        auths: [],
        innerVisible: false,
        list: {
          projectName: null,
          projectNum: null,
          startTime: null,
          endTime: null
        },
        checked: false,
        projectTableData: null,
        projectPageNo: null,
        projectPageSize: null,
        projectTotal: null,
        uploadDialog: false,
        obj: null,
        load: null,
        modelUrl: null,
        exportUrl: null,
        userIsPLUS: true,//是否是PLUS账号
        isAdmin: false,//是否是admin或者tinashi
        userIsPG: '',//是否是PG账号，这里直接存了PG账户名
      }
    },
    mounted() {
      let PlusAccount = sessionStorage.getItem('user')
      this.userIsPLUS = Boolean(PlusAccount)
      this.isAdmin = Boolean(PlusAccount && (PlusAccount == 'admin1' || PlusAccount == 'tinashi'))
      this.userIsPG = sessionStorage.getItem('usersPG')
      this.getData()
      if (this.userIsPLUS) {
        this.getAuth()
      }
    },
    methods: {
      returnName(name) {
        return this.isAdmin ? name : utils.plusXing(name, 1, 1)
      },
      downloadModel() {
        location.href = utils.returnUrlHead('temp/') + 'excel/baojie_mould.xlsx'
      },
      requireList() {
        this.uploadDialog = true
        this.time = new Date().getTime()
        this.obj = {name: this.time + 'baojie_mould.xlsx'}
      },
      exportList() {
        this.$http({
          method: "POST",
          url: "/rest/upDownload/download",
        }).then(res => {
          location.href = utils.returnUrlHead() + res.data.message;
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '下载失败，请稍后重试')
        })
      },
      handlePreview(file) {
        this.load = true
      },
      handleSuccess(response, file, fileList) {
        // console.log('上传成功后返回的数据res', response)
        // console.log(2, file)
        // console.log(3, fileList)
        // console.log(this.obj)
        if (response.message == "操作成功") {
          utils.myNotify(this, 'success', '操作成功')
          this.uploadDialog = false
          this.load = false
          // this.$http({
          //   method: "POST",
          //   url: "/rest/upDownload/download",
          // }).then(res => {
          //   this.exportUrl = utils.returnUrlHead + res.data.message
          // })

          //成功后再走此接口，后台才开始真的存储
          this.$http({
            method: "GET",
            url: "/rest/BaojieDownload/savePGCR",
          }).then(res => {
            console.log('文件上传成功')
          })
          this.getData();
        } else if (response.message.search('不在促销员库') != -1 || response.message.search('没有获取到信息') != -1 || response.message.search('失败') != -1) {
          this.$alert(response.message, '提示', {
            confirmButtonText: '确定',
          });
          this.uploadDialog = false
          this.load = false
        } else {
          this.load = false
          utils.myNotify(this, 'warning', response, '操作异常')
        }
      },
      handleError(err, file, fileList) {
        this.load = false
      },
      exportData() {
        this.innerVisible = true
      },
      avatarImg(img) {
        if (img != null) {
          return {
            'background-image': 'url(' + img + ')',
            'background-size': 'cover',
            width: '80px',
            height: '80px',
          }
        } else {
          return {
            'background-image': 'url(' + this.avatarDefault + ')',
            'background-size': 'cover',
            width: '80px',
            height: '80px',
          }
        }

      },
      handleSizeChange(val) {
        this.formData.pageSize = val
        this.getData()
      },
      handleCurrentChange(val) {
        this.formData.pageNo = val
        this.getData()
      },
      getParam(data) {
        // let pageSize = this.formData.pageSize;
        // let pageNo = this.formData.pageNo
        this.formData = data;
        // this.formData.pageSize = pageSize
        // this.formData.pageNo = pageNo
        this.getData()
      },
      getAuth() {
        this.auths = []
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 1,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          let data = res.data
          data.forEach(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      getData() {
        this.listLoading = true
        let searchURL = '/rest/salesman/search'
        // let countURL = '/rest/salesman/searchCount'
        if (this.userIsPG) {
          searchURL += 'SalesmanPG'
          // countURL += 'PG'
        }
        this.$http({
          method: "POST",
          url: searchURL,
          data: this.formData
        }).then(res => {
          this.listLoading = false;
          this.dataList = res.data.items;
          this.total = Number(res.data.totalItemsCount)
          this.dataList.map(item => {
            let n = [];
            let m = [];
            //由于传过来的数据可能有重复，而且有各种标签，在此进行过滤
            item.crmSignLst.map(item1 => {
              if (item1.id == 0 || item1.id == 1 || item1.id == 2) {
                if (m.indexOf(item1.id) == -1) {
                  n.push(item1);
                  m.push(item1.id)
                }
              }
            })
            n.map(item1 => {
              if (item1.id == 0) {
                item.isLongSign = true;
                item.isShortSign = true;
              } else if (item1.id == 1) {
                item.isLongSign = true;
              } else {
                item.isShortSign = true;
              }
            })
            item.crmSignLst = n;
          })
        }).catch(err => {
          utils.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          this.listLoading = false
        })
      },
      sortByAge(event) {
        this.formData.orderBy = 1
        this.formData.orderByAd = this.asc1 ? 1 : 2
        this.asc1 = !this.asc1
        this.getData()
      },
      //根据其他规则排序
      // sortByCredit() {
      //   this.formData.orderBy = 2
      //   this.formData.orderByAd = this.asc2 ? 1 : 2
      //   this.asc2 = !this.asc2
      //   this.getData()
      // },
      // sortByStar() {
      //   this.formData.orderBy = 3
      //   this.formData.orderByAd = this.asc3 ? 1 : 2
      //   this.asc3 = !this.asc3
      //   this.getData()
      // },
      // sortByProPrice() {
      //   this.formData.orderBy = 4
      //   this.formData.orderByAd = this.asc4 ? 1 : 2
      //   this.asc4 = !this.asc4
      //   this.getData()
      // },

      // 图片出错
      setErrorImage(event) {
        console.log('图片出错', event)
        event.target.parentNode.style.backgroundImage = `url(${this.avatarDefault})`
        // event.target.src = require('common/images/avatar-default.png')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../common/styles/variable.scss";

  div.sales-persion-card {
    width: 186px;
    height: 220px;
    border-radius: 5px;
    background: #fff;
    position: relative;
    box-sizing: border-box;
    text-align: center;
    margin-right: 18px;
    margin-bottom: 10px;
    .top-line {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 3px;
      background: #ccc;
      &.long {
        background: $theme-color;
      }
      &.short {
        background: $color-green;
      }
      &.both {
        background: $theme-font-color;
      }
    }
    @media screen and (min-width: 1790px) {
      margin-right: calc(((100% - 186px) - (186px * 8)) / 7);
      &:nth-child(8n) {
        margin-right: 0;
      }
    }
    // @media screen and (min-width: 1680px) {
    //   height: 350px;
    //   width: calc((100% - 101px) / 6);
    //   &:nth-of-type(6n){
    //     margin-right: 0;
    //   }
    // }
    @media screen and (min-width: 1556px) and (max-width: 1790px) {
      margin-right: calc(((100% - 186px) - (186px * 7)) / 6);
      &:nth-of-type(7n) {
        margin-right: 0;
      }
    }
    @media screen and (max-width: 1555px) {
      margin-right: calc(((100% - 186px) - (186px * 6)) / 5);
      &:nth-of-type(6n) {
        margin-right: 0;
      }
    }
    .tag {
      position: absolute;
      width: 100%;
      height: 20px;
      top: 8px;
      right: 10px;
      text-align: right;
      line-height: 20px;
      color: #fff;
      .tag-item {
        display: inline-block;
        width: 20px;
        height: 20px;
        background: $color-green;
        border-radius: 50%;
        text-align: center;
        margin-left: 5px;
        &.long {
          background: $theme-color;
        }
      }
    }
    .avatar {
      height: 80px;
      border-radius: 50%;
      margin: 22px 0 12px 50.5px;
      // @media screen and (min-width: 1680px) {
      //   margin-top: 40px;
      //   height: 150px;
      // }
      // @media screen and (min-width: 1580px) and (max-width: 1679px) {
      //   height: 130px;
      // }
      img {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        border: none;
        opacity: 0;
      }
    }
    .name {
      font-size: 15px;
      font-weight: bold;
      color: $theme-font-color;
      line-height: 18px;
    }
    .persional-info {
      margin: 8px 0;
      height: 13px;
      line-height: 13px;
      color: #999;
      .line {
        display: inline-block;
        width: 1px;
        height: 13px;
        background: #999;
        margin: 0 10px;
        vertical-align: top;
      }
    }
    .status {
      padding: 0 8px;
      height: 18px;
      // margin: 0 auto;
      display: inline-block;
      border-radius: 9px;
      background: $color-green;
      color: #fff;
      line-height: 18px;
      font-size: 12px;
      font-weight: normal;
      &.on-guard {
        background: $theme-color;
      }
    }
    .info {
      border-top: 1px solid #f4f4f4;
      color: #999;
      height: 40px;
      line-height: 40px;
      text-align: center;
      span {
        margin: 0 2px;
      }
    }
  }

  .listExport {
    background: #2d2c7a;
    color: #fff !important;
    border-radius: 50px;
    cursor: pointer;
    margin-left: 10px;
    display: inline-block;
    padding: 7px 10px;
  }

  .listExport:hover {
    background: #2D2CA4;
  }

  .exportButton {
    display: inline-block;
    padding: 3px 15px;
    background-color: #2d2c7a;
    color: white;
    border-radius: 7px;
    margin-left: 20px;
  }

  .roleCancelBtn,
  .roleCancelBtn:hover {
    height: 30px;
    color: #666666;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
    background-color: #ffffff;
  }

  /* 创建角色中的确定按钮样式 */
  .roleDefineBtn {
    background: #2d2c7a;
    height: 30px;
    color: #ffffff;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
  }

  // .usermangerCheck
</style>
<style lang="sass">

</style>





// WEBPACK FOOTER //
// src/views/personnelCenter/salespersonLibrary.vue